import { z } from 'zod'

import {
  createWebComponentPropertyDescriptor,
  webComponentAttributeParsers,
} from '@salsita-ai/platform-project-sdk/domain'

export const webComponentProperties = {
  shortsSize: createWebComponentPropertyDescriptor({
    schema: z.enum(['xs', 's', 'm', 'l', 'xl', '2xl', '3xl']),
    defaultValue: undefined,
    attributeParser: webComponentAttributeParsers.string,
  }),
}
